import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { CategoryService } from 'app/services/models/category.service';
import { CompanyService } from 'app/services/models/company.service';
import { CurrencyService } from 'app/services/models/currency.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  encapsulation: ViewEncapsulation.None
})
export class CompanyListComponent implements OnInit {

  constructor(
    private companyService: CompanyService,
    private router: Router,
    private categoryService: CategoryService,
    private currencyService: CurrencyService) { }
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  public searchValue = '';
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;
  async ngOnInit() {
    await this.getAllCompany(this.searchValue, this.pageBasic - 1, this.selectedSize);
  }

  filterUpdate(event) {
    const val = event.target.value.toLowerCase('tr-TR');
    this.searchValue = val;
    setTimeout(async () => {
      await this.getAllCompany(this.searchValue, this.pageBasic - 1, this.selectedSize);
    }, 500);
  }

  getFormattedLength(labels): string {
    const length = labels.length - 1;
    return length > 1 ? `(+${length})` : '';
  }

  onActivate(event: any) {
    if (event.type === 'click' && event.row) {
      this.router.navigate([`/admin/company/${event.row.id}`]);
    }
  }

  async getAllCompany(seacrh, page, size) {
    this.blockUI.start();
    try {
      const data = await this.companyService.getAllCompany(seacrh, page, size);
      this.rows = data.companies
      console.log(data);
      this.totalCount = data.totalCount;
    } catch (error) {
    }
    this.blockUI.stop()
  }

  async onPageChange(pageNumber: number) {
    await this.getAllCompany(this.searchValue, this.pageBasic - 1, this.selectedSize);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllCompany(this.searchValue, this.pageBasic - 1, this.selectedSize);
  }
}